module.exports = __webpack_public_path__ + "static/media/arrow_down.b0a786ab.svg";